import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import Navigation from "./ExtoleNavigation.vue";
import { useAppPinia } from "src/app-pinia";
import { getSharedQueryClient } from "src/resources/queryClient";
const isNavbarCollapsed = localStorage.getItem("extole_navbar_is_collapsed") === "true";
export default {
    start() {
        const queryClient = getSharedQueryClient();
        document.body.insertAdjacentHTML("afterbegin", `<div class="header-side__wrapper ${isNavbarCollapsed ? "collapsed" : ""}"></div>`);
        createApp(Navigation)
            .use(useAppPinia())
            .use(VueQueryPlugin, { queryClient })
            .mount(".header-side__wrapper");
    },
};
